import { createTerms } from './createTerms';
import { removeFromTermsValue } from './removeFromTermsValue';
import { IJsonQueryTerms } from '../../types/jsonQuery/term';

export function removeFromTerms<T>({
  jsonQuery,
  removeFromJsonQuery,
}: {
  jsonQuery: IJsonQueryTerms<T>;
  removeFromJsonQuery: IJsonQueryTerms<T>;
}) {
  const jsonQueryValue = jsonQuery?.value || [];
  const removeFromJsonQueryValue = removeFromJsonQuery?.value || [];

  const value = removeFromTermsValue({ terms: jsonQueryValue, removeTerms: removeFromJsonQueryValue });

  if (value.length === 0) {
    return null;
  }

  return createTerms(value);
}
